import { EntityState, EntityStore, StoreConfig } from '@datorama/akita';
import { SearchTerm, recordingsSearchTermTypesList, SearchType, ESearchScopes } from './search-term.model';
import { Injectable } from '@angular/core';

export interface SearchTermsState extends EntityState<SearchTerm> {
  ui: {
    searchAreaActive: boolean;
  };
  searchTypes: SearchType[];
  options: {};
  searchScope: ESearchScopes;
}

const initialState = {
  ui: {
    searchAreaActive: false
  },
  searchTypes: recordingsSearchTermTypesList,
  options: {},
  searchScope: ESearchScopes.RECORDINGS
};

@Injectable()
@StoreConfig({ name: 'SearchTerms' })
export class SearchTermsStore extends EntityStore<SearchTermsState, SearchTerm> {
  constructor() {
    super(initialState);
  }
}
